import {
  $pointAddress,
  deleteReceivingPoint,
  getBuyerPointsFx,
  setPointAddress,
} from '@/modules/seller-account/store/buyers.store';
import { notification, Modal, Checkbox } from 'antd';
import classNames from 'classnames';
import { useStore } from 'effector-react';
import { useEffect, useRef, useState } from 'react';
import styles from './index.module.sass';
import { pointsMap as map } from '../../map.model';
import moreSvg from '@@/seller-account/components/buyer-details/images/more.svg';
import { removeTrailingComma } from '@/modules/seller-account/functions/remove-trailing-comma.function';
import { handleUpdate } from '@/modules/seller-account/functions/handle-update-rp.function';
import { debounce } from 'lodash-es';
import { setViewMode } from '@/features/storage-mode-select/model';

export const HangarPoint = ({
  region,
  city,
  street,
  build,
  id,
  buyerId,
  setModalVisible,
  setPointForEditId,
  setAddressString,
  enabled,
  switchToView,
  name,
  coordinates,
  isLastEnabled,
  hasMixer,
  customDeleteFoo,
  customSwitchFoo,
  pointsNotEditable,
}: {
  id: number;
  buyerId: number;
  region: string;
  city?: string;
  street: string;
  build: string;
  hasMixer?: number;
  setModalVisible: (val: boolean) => void;
  setPointForEditId: (val: number) => void;
  setAddressString: (val: string) => void;
  enabled: number;
  switchToView: () => void;
  name: string;
  coordinates: string;
  isLastEnabled: boolean;
  customDeleteFoo?: (id: number) => Promise<unknown>,
  customSwitchFoo?: (id: number, enabled: 1 | 0) => Promise<unknown>,
  pointsNotEditable?: boolean,
}) => {
  const tooltipRef: any = useRef(null);
  const moreRef: any = useRef(null);
  const pointName = useStore($pointAddress);
  const [displayTooltip, setDisplayTooltip] = useState(false);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (
        // displayTooltip &&
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target) &&
        !moreRef.current.contains(event.target)
      ) {
        setDisplayTooltip(false);
      }
    }
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleDelete = async (id: number, buyer_id: number) => {
    const res = await deleteReceivingPoint(id);
    if ('error' in res || 'errors' in res)
      return notification.error({
        message:
          res.error || 'При удалении пункта приема возникла ошибка. Попробуйте, пожалуйста, позже',
      });
    await getBuyerPointsFx(buyer_id);
    return notification.success({
      message: 'Пункт приема зерна успешно удален из системы',
    });
  };

  const onClick = async (e: React.MouseEvent) => {
    if (pointsNotEditable) return;
    if (!displayTooltip && moreRef.current && !moreRef.current.contains(e.target)) {
      // if (isLastEnabled && enabled === 1) {
      //   return notification.warning({
      //     message: 'Единственный активный пункт приема зерна не может быть отключен',
      //   });
      // }
      if (customSwitchFoo) {
        await customSwitchFoo(id, +enabled === 1 ? 0 : 1);
        return;
      }
      const res = await handleUpdate({
        pointName: { enabled: +enabled === 1 ? 0 : 1 },
        pointForEditId: id,
        state: +enabled === 1 ? 'enabled' : 'disabled',
      } as any);
      res?.success && setPointAddress({ ...pointName, enabled: +enabled === 1 ? 0 : 1 });
      getBuyerPointsFx(buyerId);
    }
  };

  const debouncedClickHandler = debounce(onClick, 500, { maxWait: 2000 });

  const loadMap = () => {
    const crd = JSON.parse(coordinates);
    const dataObj = {
      ...pointName,
      enabled,
      region: region,
      area: city,
      street: street,
      house: build,
      name: name,
      has_mixer: hasMixer,
      latitude: crd[0],
      longitude: crd[1], 
    };
    setPointAddress(dataObj);

    const addressString = removeTrailingComma(
      `${pointName.country ? pointName.country + ',' : ''} ${
        region ? region + ',' : ''
      } ${city ? city + ',' : ''} ${street ? street + (build !== '' ? ',' : '') : ''} ${
        build || ''
      }`,
    );

    setAddressString(addressString);

    map.setMarkerByAddress(addressString, dataObj);
  };

  const parsedCoords = JSON.parse(coordinates);

  return (
    <div
      className={styles.hangarRoot}
      onClick={(e) => onClick(e)}
      style={enabled !== 1 ? { borderColor: 'rgb(170, 179, 203)' } : {}}
    >
      <div className={styles.wrap}>
        <div className={styles.requisite}>
          <span className={styles.label}>название</span>
          <span className={styles.value}>{name || ' - '}</span>
        </div>
        <div className={styles.requisite}>
          <span className={styles.label}>область</span>
          <span className={styles.value}>{region || ' - '}</span>
        </div>
        <div className={styles.requisite}>
          <span className={styles.label}>город</span>
          <span className={styles.value}>{city || '-'}</span>
        </div>
        <div className={styles.requisite}>
          <span className={styles.label}>улица</span>
          <span className={styles.value}>{street || '-'}</span>
        </div>
        <div className={styles.requisite}>
          <span className={styles.label}>дом</span>
          <span className={styles.value}>{build || '-'}</span>
        </div>
        <div className={styles.status}>
          <span className={styles.label}>статус</span>
          <span
            className={styles.value}
            style={{ color: enabled === 1 ? '#007E3C' : '#AAB3CB' }}
          >
            {enabled === 1 ? 'активен' : 'не активен'}
          </span>
        </div>
        <div className={styles.status}>
          <span className={styles.label}>миксер</span>
          <span
            className={styles.value}
            style={{ color: hasMixer === 1 ? '#007E3C' : '#AAB3CB' }}
          >
            {hasMixer === 1 ? 'есть' : 'отсутствует'}
          </span>
        </div>
        <div className={styles.requisite} style={{ marginTop: 8 }}>
          <span className={styles.label}>долгота</span>
          <span className={styles.value}>{parsedCoords[0] || '-'}</span>
        </div>
        <div className={styles.requisite}>
          <span className={styles.label}>широта</span>
          <span className={styles.value}>{parsedCoords[1] || '-'}</span>
        </div>
      </div>
      <div className={styles.more}>
        <img
          className={styles.icon}
          src={moreSvg}
          alt="more"
          onClick={() => setDisplayTooltip(!displayTooltip)}
          ref={moreRef}
        />
        <div className={styles.tooltipParent}>
          <div
            ref={tooltipRef}
            className={classNames(
              styles.tooltip,
              displayTooltip && styles.tooltip__visible,
            )}
          >
            <span
              onClick={() => {
                loadMap();
                switchToView();
                setModalVisible(true);
                setPointForEditId(id);
              }}
            >
              смотреть на карте
            </span>
            { !pointsNotEditable ? <span
              className={styles.edit}
              onClick={() => {
                loadMap();
                setModalVisible(true);
                setPointForEditId(id);
              }}
            >
              редактировать
            </span> : ''}
            { !pointsNotEditable ? <span
              className={styles.delete}
              onClick={() =>
                Modal.confirm({
                  title: 'Подтвердите действие',
                  content: 'Вы действительно хотите удалить данный пункт приема зерна?',
                  okText: 'Да',
                  cancelText: 'Нет',
                  onOk: async () => customDeleteFoo ? await customDeleteFoo(id) : await handleDelete(id, buyerId),
                  // handleDelete({
                  //   type: buyerData.type,
                  //   id: buyerData.id,
                  //   setDisplayTooltip,
                  //   company_name: buyerData.company_name,
                  // }),
                })
              }
            >
              удалить
            </span> : ''}
          </div>
        </div>
      </div>
    </div>
  );
};
